import React, { useState, useEffect, useRef } from 'react';
import NetworkCalculator from './NetworkEditor/NetworkEditor';

const MyComponent = () => {

    return (
<NetworkCalculator/>
    )
}
export default MyComponent;